import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setPayoutRequirement, setSupportedCurrencies } from 'store/slices/currency'
import { Account, Currency, Pair, PayoutRequirement } from 'types'
import { emptySplitApi } from './emptySplit.api'

// Define a service using a base URL and expected endpoints
export const currencyApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSupportedCurrencies: builder.query<{ currencies: Currency[] }, void>({
      query: () => ({
        url: 'currencies/supported?active=true',
        method: 'GET',
        responseHandler: (response) => response.json(),
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          dispatch(setSupportedCurrencies(data))
        } catch (err) {
          // `onError` side-effect
        }
      },
    }),
    getPayoutRequirements: builder.mutation<PayoutRequirement, Currency>({
      query: (currency) => ({
        url: `currencies/payout-requirements?currencyId=${currency.id}`,
        method: 'GET',
        responseHandler: (response) => response.json(),
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setPayoutRequirement({ currencyId: arg.id, requirement: data }))
          // `onSuccess` side-effect
        } catch (err) {
          // `onError` side-effect
        }
      },
    }),
    getCurrencyPair: builder.mutation<Pair, { fromCurrencyId: string; toCurrencyId: string }>({
      query: (body) => ({
        url: 'currencies/pairs',
        method: 'POST',
        body,
        responseHandler: (response) => response.json(),
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
        } catch (err) {
          // `onError` side-effect
        }
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSupportedCurrenciesQuery,
  useGetPayoutRequirementsMutation,
  useGetCurrencyPairMutation,
} = currencyApi
